import { MutationTree } from 'vuex';
import { ERROR } from './mutation-types';
import { ErrorToasterState } from './state';

export const mutations: MutationTree<ErrorToasterState> = {
    [ERROR.SET_ACTIVE](state: ErrorToasterState, isActive: boolean) :void {
        state.activeToast = isActive;
    },
    [ERROR.SET_MESSAGE](state: ErrorToasterState, message: string) :void {
        if(message !== 'silent_fail'){
            state.activeToast = true;
            state.message = message;
            setTimeout(()=>{
                state.activeToast  = false;
            },5000);
        }
    },
};
